/**
 * FormData builder for Contents API — keeps Add/Edit lean and mapping-ready.
 */
export const appendIfPresent = (formData, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    formData.append(key, value);
  }
};

export const buildContentFormData = (formData, isEditMode, id) => {
  const payload = new FormData();

  if (isEditMode && id) {
    payload.append("id", id);
    payload.append("Id", id);
  }

  payload.append("contentCategoryId", formData.contentCategoryId);
  appendIfPresent(payload, "contentTopicId", formData.contentTopicId);

  payload.append("title", (formData.title || "").trim());
  payload.append("contentSlug", (formData.contentSlug || "").trim());
  appendIfPresent(payload, "shortDescription", formData.shortDescription?.trim());
  payload.append("fullDescription", formData.fullDescription || "");

  if (formData.contentImageUrl) {
    payload.append("contentImageUrl", String(formData.contentImageUrl));
  }
  if (formData.bannerImageUrl) {
    payload.append("bannerImageUrl", String(formData.bannerImageUrl));
  }
 
  appendIfPresent(payload, "detailPageUrl", formData.detailPageUrl?.trim());
  appendIfPresent(payload, "authorName", formData.authorName?.trim());
  appendIfPresent(payload, "sourceName", formData.sourceName?.trim());
  appendIfPresent(payload, "readingTime", formData.readingTime?.trim());
  appendIfPresent(payload, "publishedOn", formData.publishedOn);

  appendIfPresent(payload, "eventsFrom", formData.eventsFrom);
  appendIfPresent(payload, "eventsTo", formData.eventsTo);
  appendIfPresent(payload, "eventLocation", formData.eventLocation?.trim());

  payload.append("isFeatured", String(Boolean(formData.isFeatured)));
  payload.append("isFeaturedHome", String(Boolean(formData.isFeaturedHome)));
  payload.append("isPremium", String(Boolean(formData.isPremium)));
  payload.append("displayOrder", formData.displayOrder);

  appendIfPresent(payload, "metaTitle", formData.metaTitle?.trim());
  appendIfPresent(payload, "metaDescription", formData.metaDescription?.trim());
  appendIfPresent(payload, "metaKeywords", formData.metaKeywords?.trim());

  return payload;
};

export const mapContentResponse = (data) => ({
  contentCategoryId: String(
    data.contentCategoryId ?? data.ContentCategoryId ?? ""
  ),
  contentTopicId: String(data.contentTopicId ?? data.ContentTopicId ?? ""),
  title: data.title || data.Title || "",
  contentSlug: data.contentSlug || data.ContentSlug || "",
  shortDescription: data.shortDescription || data.ShortDescription || "",
  fullDescription: data.fullDescription || data.FullDescription || "",
  detailPageUrl: data.detailPageUrl || data.DetailPageUrl || "",
  authorName: data.authorName || data.AuthorName || "",
  sourceName: data.sourceName || data.SourceName || "",
  readingTime: data.readingTime || data.ReadingTime || "",
  publishedOn: data.publishedOn || data.PublishedOn || "",
  eventsFrom: data.eventsFrom || data.EventsFrom || "",
  eventsTo: data.eventsTo || data.EventsTo || "",
  eventLocation: data.eventLocation || data.EventLocation || "",
  isFeatured: Boolean(data.isFeatured ?? data.IsFeatured ?? false),
  isFeaturedHome: Boolean(data.isFeaturedHome ?? data.IsFeaturedHome ?? false),
  isPremium: Boolean(data.isPremium ?? data.IsPremium ?? false),
  displayOrder:
    data.displayOrder !== undefined && data.displayOrder !== null
      ? String(data.displayOrder)
      : data.DisplayOrder !== undefined && data.DisplayOrder !== null
      ? String(data.DisplayOrder)
      : "",
  metaTitle: data.metaTitle || data.MetaTitle || "",
  metaDescription: data.metaDescription || data.MetaDescription || "",
  metaKeywords: data.metaKeywords || data.MetaKeywords || "",
  contentImagePreview:
    data.contentImageUrl ||
    data.ContentImageUrl ||
    data.thumbnailUrl ||
    data.ThumbnailUrl ||
    "",
  bannerImagePreview:
    data.bannerImageUrl || data.BannerImageUrl || "",
  contentImageFile: null,
  bannerImageFile: null,
});
